module.exports = __webpack_public_path__ + "media/images/emblems/Sursee_LU-22ff2672399eb94593817231faf3722b.png";